import React from "react";
//home page can be changed for any page
import CenterPanelCustomerNotes from "./centerPanel";
import BottomPanelCustomerNotes from "./bottomPanel";

export default function AppointmentContent() {
  return (
    <div>
      <CenterPanelCustomerNotes />
      <BottomPanelCustomerNotes />
    </div>
  );
}
